module.exports = __webpack_public_path__ + "img/1.1acd31c5.png";